module.exports = __webpack_public_path__ + "assets/images/key/key_kl_2019.svg?v=b15c844b";